import React from 'react';
import KnowledgeCentre from './components/KnowledgeCentre';


const KnowledgeCentreContainer = () => {
    return (
        <KnowledgeCentre/>
    );
};
export default KnowledgeCentreContainer;